var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { FormBuilder } from '@angular/forms';
var ReqDocumentComponent = /** @class */ (function () {
    function ReqDocumentComponent(Fb, Util, Api) {
        this.Fb = Fb;
        this.Util = Util;
        this.Api = Api;
        this.otpmobile = "";
        this.contactList = [];
        this.selectList = [];
        this.telephone1 = "";
        this.verifyOtp = "";
        this.disableResentOtp = false;
        this.isHaveDup = false;
        this.name = "";
        this.UID = "";
        this.submitted = false;
        this.submittedType = false;
        this.nameall = "";
        this.sendorprint = false;
        this.displayStyle = "none";
        this.otp = "";
        this.otpRef = "";
        this.requestOtpLbl = "ส่ง";
        this.otpTimer = "";
        this.ElapseTime = 0;
        this.TotalTime = 0;
        this.OTPCountDown = "";
        this.isCheckedAll = false;
    }
    ReqDocumentComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            function match(params, data) {
                if ($.trim(params.term) === '') {
                    return data;
                }
                if (typeof data.text === 'undefined') {
                    return null;
                }
                if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) < 0)
                    return null;
                else
                    return data;
            }
            var thisTs, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        thisTs = this;
                        this.Initcontact();
                        _a = this;
                        return [4 /*yield*/, this.getContact()];
                    case 1:
                        _a.contact = _b.sent();
                        this.nameall = this.contact.firstname + (this.contact.lastname == null ? "" : (" " + this.contact.lastname));
                        $('.select2').select2({
                            matcher: function (params, data) {
                                if ($.trim(params.term) === '') {
                                    return data;
                                }
                                // Do not display the item if there is no 'text' property
                                if (typeof data.text === 'undefined') {
                                    return null;
                                }
                                if (params.term.length > 1) {
                                    // `params.term` should be the term that is used for searching
                                    // `data.text` is the text that is displayed for the data object
                                    var cris = params.term.split(" ");
                                    var found = true;
                                    for (var i = 0; i < cris.length; i++) {
                                        if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
                                            found = false;
                                            return null;
                                        }
                                    }
                                    if (found) {
                                        // You can return modified objects from here
                                        // This includes matching the `children` how you want in nested data sets
                                        return data;
                                    }
                                }
                                // Return `null` if the term should not be displayed
                                return null;
                            },
                            placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
                        });
                        this.InitDropdown();
                        $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change');
                        this.telephone1 = this.contact.telephone1;
                        $('.select2').on("change", function (e) {
                            thisTs.AddressChange(e.target.value);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ReqDocumentComponent.prototype.InitDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.AddressList = JSON.parse(localStorage.getItem("address"));
                        if (!(this.AddressList == null || this.AddressList.length == 0)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.Api.getMasterAddress()];
                    case 1:
                        _a.AddressList = _b.sent();
                        localStorage.setItem("address", JSON.stringify(this.AddressList));
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ReqDocumentComponent.prototype.requestOtp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var reqOtp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.otpmobile = this.telephone1;
                        if (this.otpmobile.length < 10) {
                            this.Util.ErrorDialog("กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง");
                            return [2 /*return*/];
                        }
                        reqOtp = {
                            MobileNo: this.otpmobile
                        };
                        return [4 /*yield*/, this.Api.postPortal("crm", "RequestOTP", reqOtp).then(function (reqOtpRes) { return __awaiter(_this, void 0, void 0, function () {
                                var smsContent, sendSms, sendSmsRes;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.Util.isSuccessResponse(reqOtpRes)) return [3 /*break*/, 2];
                                            smsContent = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : ";
                                            smsContent += reqOtpRes.otpNo + " ";
                                            smsContent += "(RefCode : " + reqOtpRes.RefCode;
                                            smsContent += "(รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น";
                                            sendSms = {
                                                dpa_description: smsContent,
                                                dpa_phoneno: this.otpmobile
                                            };
                                            return [4 /*yield*/, this.Api.post("crmservice", "sendSms", sendSms)];
                                        case 1:
                                            sendSmsRes = _a.sent();
                                            if (this.Util.isSuccessResponse(sendSmsRes)) {
                                                this.otpRef = reqOtpRes.RefCode;
                                                this.otpTimer = 59;
                                                this.lastReqTime = new Date();
                                                this.requestOtpLbl = "ส่งอีกครั้ง";
                                                this.disableResentOtp = true;
                                                if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
                                                    this.TotalTime = 300;
                                                }
                                                else {
                                                    this.TotalTime = reqOtpRes.expInMinute * 60;
                                                }
                                                this.ElapseTime = 0;
                                                if (this.SubScr != undefined) {
                                                    this.SubScr.unsubscribe();
                                                }
                                                //this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
                                            }
                                            else {
                                                this.Util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            this.Util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReqDocumentComponent.prototype.verify = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reqCheckOtp, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.verifyOtp.trim().length > 0)) return [3 /*break*/, 2];
                        this.Util.ShowWaiting(true);
                        reqCheckOtp = {
                            OTP: this.verifyOtp.trim(),
                            RefCode: this.otpRef.trim(),
                            MobileNo: this.telephone1
                        };
                        return [4 /*yield*/, this.Api.postPortal("crm", "VerifyOTP", reqCheckOtp)];
                    case 1:
                        Res = _a.sent();
                        if (this.Util.isSuccessResponse(Res)) {
                            console.log(Res.IsValid);
                            if (Res.IsValid) {
                                //update ข้อมูลผ่าน api updateCRM08DROS 
                                if (this.sendorprint) {
                                    this.updateCRM08DROS(this.contact);
                                    this.Util.ShowWaiting(false);
                                    window.location.reload();
                                }
                                else {
                                    this.getFile(this.contact);
                                    this.Util.ShowWaiting(false);
                                }
                                //this.util.SuccessDialog("ขอเอกสารสำเร็จ");
                            }
                            else {
                                this.Util.ShowWaiting(false);
                                this.Util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง");
                            }
                        }
                        else {
                            this.Util.ShowWaiting(false);
                            this.Util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.Util.WarningDialog("กรุณากรอกรหัส OTP");
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReqDocumentComponent.prototype.CountDownOTP = function () {
        if (this.ElapseTime == 0 && this.TotalTime == 0) {
            this.SubScr.unsubscribe();
            return;
        }
        if (this.ElapseTime == this.TotalTime) {
            this.SubScr.unsubscribe();
            $("#btnSubmitOTP").attr("disabled", "disabled");
            $("#btnSubmitOTP").html("ยืนยัน");
            this.ElapseTime = 0;
            return;
        }
        this.ElapseTime++;
        var RemainingSecs = this.TotalTime - this.ElapseTime;
        var RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
        RemainingSecs = RemainingSecs % 60;
        $("#btnSubmitOTP").html("ยืนยัน " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs);
    };
    ReqDocumentComponent.prototype.CountDownWaitTime = function () {
        if (this.WaitTime == 0) {
            $("#btnRequestOTP").html("ขอรหัสอีกครั้ง");
            $("#btnRequestOTP").removeAttr("disabled");
            this.SubScr2.unsubscribe();
            return;
        }
        this.WaitTime--;
        $("#btnRequestOTP").html("ขอรหัสอีกครั้ง " + this.WaitTime);
    };
    ReqDocumentComponent.prototype.updateCRM08DROS = function (inputcontact) {
        return __awaiter(this, void 0, void 0, function () {
            var that, req, Addresstext, MooNotext, StreetNametext, subdistic, Zipcodetext, UIDtext, MobileNo, Res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        req = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        Addresstext = this.contact.dpa_contact_homeno;
                        MooNotext = this.contact.dpa_contact_moo;
                        StreetNametext = this.contact.dpa_contact_street;
                        subdistic = this.contact.dpa_contact_subdistict;
                        Zipcodetext = this.contact.dpa_contact_postcodename;
                        UIDtext = this.UID;
                        MobileNo = this.otpmobile;
                        $('.row-checker:checkbox:checked').each(function () {
                            var value = {
                                RequestedNo: $(this).val()
                            };
                            //console.log(value.RequestedNo);
                            var reqdetail = {
                                DROSRequestNo: value.RequestedNo,
                                UID: UIDtext,
                                Status: "P",
                                Address: Addresstext,
                                MooNo: MooNotext,
                                StreetName: StreetNametext,
                                LocationCode: subdistic,
                                Zipcode: Zipcodetext,
                                PhoneNo: MobileNo,
                            };
                            req.push(reqdetail);
                        });
                        return [4 /*yield*/, this.Api.post("crmservice", "updateCRM08DROS", req)];
                    case 2:
                        Res = _a.sent();
                        if (Res != null && Res["Status"] != null && parseInt(Res["Status"]) == 200) {
                            this.displayStyle = "none";
                            this.otpRef = "";
                            this.verifyOtp = "";
                            this.disableResentOtp = false;
                            this.Util.ShowWaiting(false);
                            this.Util.SuccessDialog("ขอเอกสารสำเร็จ");
                        }
                        else if (Res != null && Res["Status"] != null && parseInt(Res["Status"]) == 201) {
                            this.displayStyle = "none";
                            this.otpRef = "";
                            this.verifyOtp = "";
                            this.disableResentOtp = false;
                            this.Util.ShowWaiting(false);
                            this.Util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ มีคำขอซ้ำในระบบ");
                        }
                        else {
                            this.displayStyle = "none";
                            this.otpRef = "";
                            this.verifyOtp = "";
                            this.disableResentOtp = false;
                            this.Util.ShowWaiting(false);
                            this.Util.ErrorDialog("ขอเอกสารไม่สำเร็จ");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReqDocumentComponent.prototype.getFile = function (inputcontact) {
        return __awaiter(this, void 0, void 0, function () {
            var that, req, filedata, _i, req_1, reqs, para, tmp, fields, vfilename, linkSource, objbuilder, win, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        req = [];
                        filedata = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        $('.row-checker:checkbox:checked').each(function () {
                            var row = $(this).closest("tr")[0];
                            var value = {
                                RequestedNo: $(this).val(),
                                FilePath: row.cells[5].innerHTML
                            };
                            req.push(value);
                        });
                        console.log(req);
                        _i = 0, req_1 = req;
                        _a.label = 2;
                    case 2:
                        if (!(_i < req_1.length)) return [3 /*break*/, 5];
                        reqs = req_1[_i];
                        console.log(reqs.FilePath);
                        para = "FilePath=" + reqs.FilePath;
                        return [4 /*yield*/, this.Api.get("crmservice", "getFileDROS2", para)];
                    case 3:
                        tmp = _a.sent();
                        fields = para.split('/');
                        vfilename = fields[fields.length - 1];
                        linkSource = tmp.File;
                        objbuilder = '';
                        objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
                        objbuilder += (linkSource);
                        objbuilder += ('" type="application/pdf" class="internal">');
                        objbuilder += ('<embed src="data:application/pdf;base64,');
                        objbuilder += (linkSource);
                        objbuilder += ('" type="application/pdf"  />');
                        objbuilder += ('</object>');
                        win = window.open("#", vfilename, "_blank");
                        win.document.write('<html><title>' + vfilename + '</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
                        win.document.write(objbuilder);
                        win.document.write('</body></html>');
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        this.otpRef = "";
                        this.verifyOtp = "";
                        this.displayStyle = "none";
                        this.disableResentOtp = false;
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _a.sent();
                        console.error(e_2);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ReqDocumentComponent.prototype.opennewpage = function (a, b) {
        return __awaiter(this, void 0, void 0, function () {
            var win2, html;
            return __generator(this, function (_a) {
                win2 = window.open("", "_blank");
                html = '';
                html += '<html><head><title>' + a + '</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>';
                html += '<body style="margin:0!important">';
                html += '<embed width="100%" height="100%" src="data:application/pdf;base64,' + encodeURI(b) + '" type="application/pdf" />';
                html += '</body>';
                html += '</html>';
                setTimeout(function () {
                    win2.document.write(html);
                }, 0);
                return [2 /*return*/];
            });
        });
    };
    ReqDocumentComponent.prototype.Initcontact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dpa_contact_id, dpa_contact_account, QueryString, Res, _i, _a, itm, reqdetail;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        dpa_contact_id = localStorage.getItem("cusid");
                        dpa_contact_account = localStorage.getItem("cusaccno");
                        QueryString = "CRM03=true&CRM07=true&CRM02=true";
                        if (dpa_contact_id != "")
                            QueryString += "&dpa_id=" + dpa_contact_id;
                        if (dpa_contact_account != "")
                            QueryString += "&dpa_accountno=" + dpa_contact_account;
                        return [4 /*yield*/, this.Api.get("crmservice", "contactDros", QueryString)];
                    case 1:
                        Res = _b.sent();
                        this.contactListAll = Res.CRM03.filter(function (a) { return a.FilePath != null; });
                        for (_i = 0, _a = this.contactListAll; _i < _a.length; _i++) {
                            itm = _a[_i];
                            if (itm.FilePath.split('_')[1] != "05.pdf" && itm.FilePath.split('_')[1] != "07.pdf") {
                                reqdetail = {
                                    RequestedNo: itm.RequestedNo,
                                    RequestType: itm.RequestType,
                                    StatusDefinition: itm.StatusDefinition,
                                    isPrintMessage: itm.IsPrint == 1 ? "มีการขอเอกสารแล้ว" : ("สามารถขอเอกสารได้"),
                                    UID: itm.UID,
                                    isPrint: itm.IsPrint,
                                    FilePath: itm.FilePath,
                                };
                                this.contactList.push(reqdetail);
                            }
                        }
                        if (Res != null && Res.CRM02 != null) {
                            this.UID = Res.CRM02[0].UID;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ReqDocumentComponent.prototype.getContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "cusid=" + localStorage.getItem("cusid") + "&accountno=" + localStorage.getItem("cusaccno");
                        return [4 /*yield*/, this.Api.get("crmservice", "contact", para)];
                    case 1:
                        tmp = _a.sent();
                        if (tmp != null && tmp.length > 0) {
                            return [2 /*return*/, tmp[0]];
                        }
                        else {
                            value = {
                                firstname: "",
                                dpa_contact_homeno: "",
                                dpa_contact_moo: "",
                                dpa_contact_street: "",
                                dpa_contact_subdistict: "",
                                dpa_contact_distict: "",
                                dpa_contact_province: "",
                                dpa_contact_postcode: "",
                                dpa_contact_country: "",
                                telephone1: "",
                                dpa_contact_subdistictname: "",
                                dpa_contact_distictname: "",
                                dpa_contact_provincname: "",
                                dpa_contact_postcodename: "",
                                dpa_contact_countryname: "",
                            };
                            return [2 /*return*/, value];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ReqDocumentComponent.prototype.senddata = function (i) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (i == 2) {
                    this.submitted = true;
                    this.sendorprint = true;
                    if (this.isFormValid()) {
                        this.getSelectedContact(i);
                    }
                }
                else {
                    this.submitted = false;
                    this.sendorprint = false;
                    this.getSelectedContact(i);
                    if (this.selectList.length < 1) {
                        this.Util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
                    }
                    else {
                        this.displayStyle = "block";
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    ReqDocumentComponent.prototype.onCheckAllChange = function () {
        $(".row-checker").prop("checked", this.isCheckedAll);
    };
    ReqDocumentComponent.prototype.getSelectedContact = function (i) {
        var HaveDup = false;
        var that = this;
        that.selectList = [];
        if (i == 2) {
            $("#tbcrm03 input[type=checkbox]:checked").each(function () {
                var row = $(this).closest("tr")[0];
                console.log(row.cells);
                var rowCRM03 = {
                    isPrint: row.cells[4].innerHTML
                };
                if (rowCRM03.isPrint != 1) {
                    that.selectList.push(rowCRM03);
                }
                else {
                    HaveDup = true;
                }
            });
            if (HaveDup) {
                this.Util.WarningDialog("กรุณาเลือกเฉพาะรายการที่สามารถขอเอกสารได้");
            }
            else if (that.selectList.length < 1) {
                this.Util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
            }
            else {
                this.displayStyle = "block";
            }
        }
        else {
            $('.row-checker:checkbox:checked').each(function () {
                var value = {
                    isPrint: $(this).val(),
                };
                that.selectList.push(value);
            });
        }
    };
    ReqDocumentComponent.prototype.AddressChange = function (value) {
        if (this.AddressList == null)
            return;
        var Rec = this.AddressList.filter(function (a) { return a.id == value; });
        if (Rec != null && Rec.length > 0) {
            var Values = Rec[0].id.split("|");
            var Text_1 = Rec[0].text.split("|");
            this.contact.dpa_contact_subdistict = Values[0].trim();
            this.contact.dpa_contact_distict = Values[1].trim();
            this.contact.dpa_contact_province = Values[2].trim();
            this.contact.dpa_contact_postcode = Values[3].trim();
            this.contact.dpa_contact_subdistictname = Text_1[0].trim();
            this.contact.dpa_contact_distictname = Text_1[1].trim();
            this.contact.dpa_contact_provincname = Text_1[2].trim();
            this.contact.dpa_contact_postcodename = Text_1[3].trim();
        }
        else {
            this.contact.dpa_contact_subdistict = "";
            this.contact.dpa_contact_distict = "";
            this.contact.dpa_contact_province = "";
            this.contact.dpa_contact_postcode = "";
            this.contact.dpa_contact_subdistictname = "";
            this.contact.dpa_contact_distictname = "";
            this.contact.dpa_contact_provincname = "";
            this.contact.dpa_contact_postcodename = "";
        }
    };
    ReqDocumentComponent.prototype.isFormValid = function () {
        if (this.contact.firstname == null) {
            this.contact.firstname = "";
        }
        if (this.contact.dpa_contact_homeno == null) {
            this.contact.dpa_contact_homeno = "";
        }
        if (this.contact.dpa_contact_subdistictname == null) {
            this.contact.dpa_contact_subdistictname = "";
        }
        if (this.contact.dpa_contact_distictname == null) {
            this.contact.dpa_contact_distictname = "";
        }
        if (this.contact.dpa_contact_provincname == null) {
            this.contact.dpa_contact_provincname = "";
        }
        if (this.contact.dpa_contact_postcodename == null) {
            this.contact.dpa_contact_postcodename = "";
        }
        return this.contact.dpa_contact_homeno != null &&
            this.contact.dpa_contact_homeno.trim().length > 0 &&
            this.contact.dpa_contact_subdistictname != null &&
            this.contact.dpa_contact_subdistictname.trim().length > 0 &&
            this.contact.dpa_contact_distictname != null &&
            this.contact.dpa_contact_distictname.trim().length > 0 &&
            this.contact.dpa_contact_provincname != null &&
            this.contact.dpa_contact_provincname.trim().length > 0 &&
            this.contact.dpa_contact_postcodename != null &&
            this.contact.dpa_contact_postcodename.trim().length > 0;
    };
    ReqDocumentComponent.prototype.close = function () {
        this.displayStyle = "none";
        this.otpRef = "";
        this.verifyOtp = "";
        this.disableResentOtp = false;
    };
    return ReqDocumentComponent;
}());
export { ReqDocumentComponent };



// WEBPACK FOOTER //
// ./src/app/req-document/req-document.component.ts.pre-build-optimizer.js